// Pluralization helper. uk/ru use the Slavic 3-form rule; en uses 2 forms.
// forms: { one, few, many }. For en, `many` acts as the "other" form.
export function plural(lang, n, forms) {
  const abs = Math.abs(Number(n) || 0);
  if (lang === "en") {
    return abs === 1 ? forms.one : (forms.many || forms.few || forms.one);
  }
  const mod10 = abs % 10;
  const mod100 = abs % 100;
  if (mod10 === 1 && mod100 !== 11) return forms.one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return forms.few;
  return forms.many;
}
